import './welcome-animate.component.css'

interface WelcomeAnimateProps { 
    show: boolean
}

export default function WelcomeAnimateComponent(props: WelcomeAnimateProps ) {

    return (
        props.show
        ?
        <div className="welcome-animate-class ">
            
            <div className="flex flex-column justify-content-center align-items-center w-full h-full">

                <div className='fade-in logo-welcome'>
                    <img src="/new_icons/MySalusAPP_PITTOGRAMMA_WHITE.svg" alt="" />
                </div>
                
                <div className='welcome-animate-content-benvenuto mt-4'>
                    <div>
                        Benvenuto in
                    </div>
                </div>
                <div className="flex flex-column align-items-center justify-content-center">
                        

                    <div className='welcome-animate-content font-bold'>
                        <div>
                            MySalusApp
                        </div>
                    </div>

                </div>
            </div>
        </div>
        :
        <></>
    )
}